// Version : 1.0.0
// Author : AGALYA
import { takeLatest, put, all, call } from 'redux-saga/effects';
import CreditCheckActionType from './credit-check.types';
import {
	creditCheckMemberAddSuccess,
	creditCheckMemberAddFailure,
	creditCheckMemberAddUserResponseChanged,
	creditCheckCallSuccess,
	creditCheckCallFailure,
	creditCheckCallUserResponseChanged,
	verifyMemberUserResponseChanged,
	verifyMemberFailure,
	verifyMemberSuccess,
	sendVerificationOtpSuccess,
	sendVerificationOtpFailure,
	sendVerificationOtpResponseChanged,
	verifyCreditCheckAadharOtpResponseChanged,
	verifyCreditCheckAadharOtpFailure,
	verifyCreditCheckAadharOtpSuccess,
	verifyValidateCreditCheckAadharOtpResponseChanged,
	verifyValidateCreditCheckAadharOtpFailure,
	verifyValidateCreditCheckAadharOtpSuccess,
	recheckMemberDetailsSuccess,
	recheckMemberDetailsFailure,
	recheckMemberDetailsResponseChanged,
	equifaxCheckCallUserResponseChanged,
	equifaxCheckCallSuccess,
	equifaxCheckCallFailure,
} from './credit-check.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	callVerifyMemberAPI,
	creditCheckMemberAdd,
	getCreditCheck,
	getEquifaxCheck,
	otpVerificationCodeSend,
	verifyCreditCheckAadharOtpAPI,
	verifyValidateCreditCheckAadharOtpAPI,
	callVerifyMemberDetailsAPI,
} from './credit-check.service';

/** ***************** CREDIT CHECK MEMBER ADD START *********************** */
export function* AddCreditCheckMember({ payload }: any) {
	try {
		const key = 'AddMemberCreditCheckMember';
		const {
			companyID,
			databaseName,
			userID,
			memberID,
			memberName,
			memberDateOfBirth,
			memberGender,
			memberPhoneNumber,
			memberAadharNumber,
			idProofType,
			idProofNumber,
			appliedAmount,
			memberFatherName,
			pincode,
			doorNo,
			addressStreet,
			country,
			state,
			district,
			postOffice,
			currentPincode,
			currentDoorNo,
			currentAddressStreet,
			currentCountry,
			currentState,
			currentDistrict,
			currentPostOffice,
			isAadharScanned,
			centerSelectValue,
		} = payload;

		const jsonData = {
			MemberCompanyID: companyID,
			DatabaseName: databaseName,
			MemberCreatedBy: userID,
			MemberID: memberID,
			MemberName: memberName,
			MemberDateOfBirth: memberDateOfBirth,
			MemberGender: memberGender,
			MemberPhoneNumber: memberPhoneNumber,
			MemberAadharNumber: memberAadharNumber,
			IdProofType: idProofType,
			IdProofNumber: idProofNumber,
			AppliedAmount: appliedAmount,
			MemberFatherName: memberFatherName,
			MemberPincode: pincode,
			MemberDoorNo: doorNo,
			MemberAddressStreet: addressStreet,
			MemberCountry: country,
			MemberState: state,
			MemberDistrict: district,
			MemberPostOffice: postOffice,
			CurrentPincode: currentPincode,
			CurrentDoorNo: currentDoorNo,
			CurrentAddressStreet: currentAddressStreet,
			CurrentCountry: currentCountry,
			CurrentState: currentState,
			CurrentDistrict: currentDistrict,
			currentPostOffice: currentPostOffice,
			IsAadharScanned: isAadharScanned,
			LocationId: centerSelectValue,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(creditCheckMemberAdd, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(creditCheckMemberAddFailure(responseData.data));
		} else {
			yield put(creditCheckMemberAddSuccess(responseData.data));
		}
	} catch (error) {
		yield put(creditCheckMemberAddFailure(error));
	}
}

export function* AddCreditCheckMemberResponseClear() {
	yield put(creditCheckMemberAddUserResponseChanged());
}

export function* onCreditCheckMemberAddStart() {
	yield takeLatest(CreditCheckActionType.CREDIT_CHECK_MEMBER_ADD_START, AddCreditCheckMember);
}

export function* onCreditCheckMemberAddResponseRest() {
	yield takeLatest(
		CreditCheckActionType.CREDIT_CHECK_MEMBER_ADD_RESPONSE_REST_START,
		AddCreditCheckMemberResponseClear,
	);
}
/** ***************** CREDIT CHECK MEMBER ADD END *********************** */

/** ***************** CREDIT CHECK CALL START *********************** */
export function* CallCreditCheck({ payload }: any) {
	try {
		const key = 'CallHighMarkDetailsKey';
		const {
			MemberID,
			databaseName,
			companyID,
			userID,
			isConsumerReport,
			appliedAmount,
			generalCompanyID,
		} = payload;

		const jsonData = {
			MemberID,
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			IsConsumer: isConsumerReport,
			AppliedAmount: appliedAmount,
			GeneralCompanyID: generalCompanyID,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getCreditCheck, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(creditCheckCallFailure(responseData.data));
		} else {
			yield put(creditCheckCallSuccess(responseData.data));
		}
	} catch (error) {
		yield put(creditCheckCallFailure(error));
	}
}

export function* CallCreditCheckResponseClear() {
	yield put(creditCheckCallUserResponseChanged());
}

export function* onCreditCheckCallStart() {
	yield takeLatest(CreditCheckActionType.CREDIT_CHECK_CALL_START, CallCreditCheck);
}

export function* onCreditCheckCallResponseRest() {
	yield takeLatest(
		CreditCheckActionType.CREDIT_CHECK_CALL_RESPONSE_REST_START,
		CallCreditCheckResponseClear,
	);
}
/** ***************** CREDIT CHECK CALL END *********************** */

/** ***************** EQUIFAX CHECK CALL START *********************** */
export function* CallEquifaxCheck({ payload }: any) {
	try {
		const key = 'AppCheckEquifaxKey';
		const {
			MemberID,
			databaseName,
			companyID,
			userID,
			isConsumerReport,
			appliedAmount,
			generalCompanyID,
		} = payload;

		const jsonData = {
			MemberID,
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			IsConsumerReport: isConsumerReport,
			AppliedAmount: appliedAmount,
			GeneralCompanyID: generalCompanyID,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getEquifaxCheck, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(equifaxCheckCallFailure(responseData.data));
		} else {
			yield put(equifaxCheckCallSuccess(responseData.data));
		}
	} catch (error) {
		yield put(equifaxCheckCallFailure(error));
	}
}

export function* CallEquifaxCheckResponseClear() {
	yield put(equifaxCheckCallUserResponseChanged());
}

export function* onEquifaxCheckCallStart() {
	yield takeLatest(CreditCheckActionType.EQUIFAX_CHECK_CALL_START, CallEquifaxCheck);
}

export function* onEquifaxCheckCallResponseRest() {
	yield takeLatest(
		CreditCheckActionType.EQUIFAX_CHECK_CALL_RESPONSE_REST_START,
		CallEquifaxCheckResponseClear,
	);
}
/** ***************** EQUIFAX CHECK CALL END *********************** */

/** ***************** VERIFY MEMBER CALL START *********************** */
export function* CallVerifyMember({ payload }: any) {
	try {
		const key = 'CheckMemberDataKey';
		const {
			memberID,
			databaseName,
			companyID,
			memberAadharNumber,
			memberPhoneNumber,
			idProofNumber,
			idProofType,
			sendOTP,
			searchAddressProofType,
			addressProofNumber,
		} = payload;

		const jsonData = {
			MemberID: memberID,
			DatabaseName: databaseName,
			MemberCompanyID: companyID,
			AadharNumber: memberAadharNumber,
			PhoneNumber: memberPhoneNumber,
			IDProofNumber: idProofNumber,
			SearchIDProofType: idProofType,
			SearchAddressProofType: searchAddressProofType,
			AddressProofNumber: addressProofNumber,
			Secratekey: key,
			SendOTP: sendOTP,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(callVerifyMemberAPI, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(verifyMemberFailure(responseData.data));
		} else {
			yield put(verifyMemberSuccess(responseData.data));
		}
	} catch (error) {
		yield put(verifyMemberFailure(error));
	}
}

export function* VerifyMemberResponseClear() {
	yield put(verifyMemberUserResponseChanged());
}

export function* onVerifyMemberStart() {
	yield takeLatest(CreditCheckActionType.VERIFY_MEMBER_START, CallVerifyMember);
}

export function* onVerifyMemberResponseRest() {
	yield takeLatest(
		CreditCheckActionType.VERIFY_MEMBER_RESPONSE_RESET_START,
		VerifyMemberResponseClear,
	);
}
/** ***************** VERIFY MEMBER CALL END *********************** */

/** ***************** SEND VERIFICATION OTP CALL START *********************** */
export function* verificationOtpSend({ payload }: any) {
	try {
		const key = 'PhoneNumberVerification';
		const { databaseName, companyID, memberPhoneNumber } = payload;

		const jsonData = {
			DatabaseName: databaseName,
			MemberCompanyID: companyID,
			MemberPhoneNumber: memberPhoneNumber,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(otpVerificationCodeSend, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(sendVerificationOtpFailure(responseData.data));
		} else {
			yield put(sendVerificationOtpSuccess(responseData.data));
		}
	} catch (error) {
		yield put(sendVerificationOtpFailure(error));
	}
}

export function* sendVerificationOtpResponseClear() {
	yield put(sendVerificationOtpResponseChanged());
}

export function* onSendVerificationOtpStart() {
	yield takeLatest(CreditCheckActionType.SEND_VERIFICATION_OTP_START, verificationOtpSend);
}

export function* onSendVerificationOtpResponseRest() {
	yield takeLatest(
		CreditCheckActionType.SEND_VERIFICATION_OTP_RESPONSE_RESET_START,
		sendVerificationOtpResponseClear,
	);
}
/** ***************** SEND VERIFICATION OTP CALL END *********************** */

/** ***************** VERIFY CREDIT CHECK AADHAR OTP CALL START *********************** */
export function* toVerifyCreditCheckAadharOtp({ payload }: any) {
	try {
		const key = 'AppVerifyKYCKey';
		const {
			companyID,
			userID,
			databaseName,
			memberID,
			generalCompanyID,
			memberCredential,
			type,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
			MemberID: memberID,
			GeneralCompanyID: generalCompanyID,
			MemberCredential: memberCredential,
			Type: type,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			verifyCreditCheckAadharOtpAPI,
			verifyData,
			payload.serviceName,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(verifyCreditCheckAadharOtpFailure(responseData.data));
		} else {
			yield put(verifyCreditCheckAadharOtpSuccess(responseData.data));
		}
	} catch (error) {
		yield put(verifyCreditCheckAadharOtpFailure(error));
	}
}

export function* VerifyCreditCheckAadharOtpResponseClear() {
	yield put(verifyCreditCheckAadharOtpResponseChanged());
}

export function* onVerifyCreditCheckAadharOtpStart() {
	yield takeLatest(
		CreditCheckActionType.VERIFY_CREDIT_CHECK_AADHAR_OTP_START,
		toVerifyCreditCheckAadharOtp,
	);
}

export function* onVerifyCreditCheckAadharOtpRest() {
	yield takeLatest(
		CreditCheckActionType.VERIFY_CREDIT_CHECK_AADHAR_OTP_RESPONSE_RESET_START,
		VerifyCreditCheckAadharOtpResponseClear,
	);
}
/** ***************** VERIFY CREDIT CHECK AADHAR OTP CALL END *********************** */

/** ***************** VALIDATE CREDIT CHECK AADHAR OTP CALL START *********************** */
export function* toVerifyValidateCreditCheckAadharOtp({ payload }: any) {
	try {
		const key = 'AppVerifyKYCKey';
		const { companyID, userID, databaseName, memberID, generalCompanyID, randNum, otp, type } =
			payload;

		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
			MemberID: memberID,
			GeneralCompanyID: generalCompanyID,
			RandNum: randNum,
			Otp: otp,
			Type: type,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			verifyValidateCreditCheckAadharOtpAPI,
			verifyData,
			payload.serviceName,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(verifyValidateCreditCheckAadharOtpFailure(responseData.data));
		} else {
			yield put(verifyValidateCreditCheckAadharOtpSuccess(responseData.data));
		}
	} catch (error) {
		yield put(verifyValidateCreditCheckAadharOtpFailure(error));
	}
}

export function* VerifyValidateCreditCheckAadharOtpResponseClear() {
	yield put(verifyValidateCreditCheckAadharOtpResponseChanged());
}

export function* onVerifyValidateCreditCheckAadharOtpStart() {
	yield takeLatest(
		CreditCheckActionType.VERIFY_VALIDATE_CREDIT_CHECK_AADHAR_OTP_START,
		toVerifyValidateCreditCheckAadharOtp,
	);
}

export function* onVerifyValidateCreditCheckAadharOtpRest() {
	yield takeLatest(
		CreditCheckActionType.VERIFY_VALIDATE_CREDIT_CHECK_AADHAR_OTP_RESPONSE_RESET_START,
		VerifyValidateCreditCheckAadharOtpResponseClear,
	);
}
/** ***************** VALIDATE CREDIT CHECK AADHAR OTP CALL END *********************** */

/** ***************** CHECK MEMBER DETAILS FOR CRIF CALL START *********************** */
export function* toCheckMemberDetails({ payload }: any) {
	try {
		const key = 'MemberCreditCheckDetails';
		const { companyID, userID, databaseName, memberID } = payload;
		const jsonData = {
			MemberCompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
			MemberID: memberID,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(callVerifyMemberDetailsAPI, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(recheckMemberDetailsFailure(responseData.data));
		} else {
			yield put(recheckMemberDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(recheckMemberDetailsFailure(error));
	}
}

export function* CheckMemberDetailsResponseClear() {
	yield put(recheckMemberDetailsResponseChanged());
}

export function* onCheckMemberDetailsStart() {
	yield takeLatest(
		CreditCheckActionType.RECHECK_MEMBER_DETAILS_FOR_CRIF_START,
		toCheckMemberDetails,
	);
}

export function* onCheckMemberDetailsReset() {
	yield takeLatest(
		CreditCheckActionType.RECHECK_MEMBER_DETAILS_FOR_CRIF_RESPONSE_RESET_START,
		CheckMemberDetailsResponseClear,
	);
}
/** ***************** CHECK MEMBER DETAILS FOR CRIF CALL END *********************** */

export function* creditCheckDetailsSaga() {
	yield all([
		call(onCreditCheckMemberAddStart),
		call(onCreditCheckMemberAddResponseRest),
		call(onCreditCheckCallStart),
		call(onCreditCheckCallResponseRest),
		call(onVerifyMemberStart),
		call(onVerifyMemberResponseRest),
		call(onSendVerificationOtpStart),
		call(onSendVerificationOtpResponseRest),
		call(onVerifyCreditCheckAadharOtpStart),
		call(onVerifyCreditCheckAadharOtpRest),
		call(onVerifyValidateCreditCheckAadharOtpStart),
		call(onVerifyValidateCreditCheckAadharOtpRest),
		call(onCheckMemberDetailsStart),
		call(onCheckMemberDetailsReset),
		call(onEquifaxCheckCallStart),
		call(onEquifaxCheckCallResponseRest),
	]);
}
